import axiosRequest from "@/utils/axiosRequest";

export function getTotal(data) {
  return axiosRequest({
    url: `/analysis/getTotal`,
    data,
    method: "post"
  });
}

export function getRunningChart(data) {
  return axiosRequest({
    url: `/analysis/getRunningChart`,
    data,
    method: "post"
  });
}

export function getSubRunningChart(data) {
  return axiosRequest({
    url: `/analysis/getSubRunningChart`,
    data,
    method: "post"
  });
}

